module.exports = __webpack_public_path__ + "src/assets/games/60/lz2.gif";